import {catchError, EMPTY, map, switchMap, tap} from "rxjs";
import {Injectable} from "@angular/core";
import {Router} from "@angular/router";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import {API} from "../../shared/api";
import {createExceptionData, deleteExceptionData, updateExceptionData,} from "./createorupdateexception.action";
import {fetchRemarkData} from "../createoredit/createoredit.action";

@Injectable()
export class CreateOrUpdateExceptionEffects {

    constructor(private action$: Actions, private api: API, private router: Router) {}

    createException$ = createEffect(() => this.action$.pipe(
        ofType(createExceptionData),
        switchMap(({ remarkId, exception }) => this.api.createRemarkException(remarkId, exception).pipe(
            tap(() => this.router.navigate([`admin/edit/${remarkId}`])),
            catchError(() => EMPTY),
        ))
    ), { dispatch: false });

    updateException$ = createEffect(() => this.action$.pipe(
        ofType(updateExceptionData),
        switchMap(({ remarkId, exception }) => this.api.updateRemarkException(remarkId, exception).pipe(
            tap(() => this.router.navigate([`admin/edit/${remarkId}`])),
            catchError(() => EMPTY),
        ))
    ), { dispatch: false });

    deleteException$ = createEffect(() => this.action$.pipe(
        ofType(deleteExceptionData),
        switchMap(({ remarkId, exceptionId }) => this.api.deleteRemarkException(remarkId, exceptionId).pipe(
            map(() => fetchRemarkData({ remarkId })),
            catchError(() => EMPTY),
        ))
    ));
}
